// Product image slider functionality - ensures arrows work with Webflow slider
document.addEventListener('DOMContentLoaded', function() {
  // Wait for Webflow to initialize
  setTimeout(function() {
    const sliders = document.querySelectorAll('.shop-details-slider.w-slider');
    
    sliders.forEach(function(slider) {
      const leftArrow = slider.querySelector('.shop-details-left-arrow.w-slider-arrow-left');
      const rightArrow = slider.querySelector('.shop-details-right-arrow.w-slider-arrow-right');
      
      // Ensure arrows are clickable and trigger Webflow slider
      if (leftArrow) {
        leftArrow.addEventListener('click', function(e) {
          // Let Webflow handle it, but ensure it's clickable
          const webflowLeft = slider.querySelector('.w-slider-arrow-left');
          if (webflowLeft && webflowLeft !== leftArrow) {
            webflowLeft.click();
          }
        });
      }
      
      if (rightArrow) {
        rightArrow.addEventListener('click', function(e) {
          // Let Webflow handle it, but ensure it's clickable
          const webflowRight = slider.querySelector('.w-slider-arrow-right');
          if (webflowRight && webflowRight !== rightArrow) {
            webflowRight.click();
          }
        });
      }
    });
  }, 500);
});

